export default "__VITE_ASSET__00b55c04__"